<template>
  <v-row no-gutters>
    <v-col cols="10">
      <v-autocomplete
        prepend-inner-icon="mdi-school-outline"
        label="Skills"
        closable-chips
        clearable
        clear-on-select
        v-model="localFilter.SelectedSkills"
        :custom-filter="utils.skillFilterFunction"
        :items="refstore.Skills"
        auto-select-first="exact"
        item-title="name"
        item-value="id"
        chips
        ref="autocomplete0"
        @update:modelValue="closeDropdown"
        multiple
      />
    </v-col>
    <v-col cols="2" class="pl-1">
      <span>Comb.</span>
      <v-checkbox class="mt-n2" v-model="localFilter.Allskills" />
    </v-col>
  </v-row>
</template>

<script>
import { ReferentialStore } from '@/stores'
import { LynxUtils } from '@/utils'

export default {
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  computed: {
    localFilter: {
      get () {
        return this.filter
      }
      /*
      ,
      set (value) {
        this.$emit('update:filter', value)
      }
      */
    },
    refstore: function () {
      return ReferentialStore()
    },
    utils: function () {
      return LynxUtils
    }
  },
  methods: {
    closeDropdown () {
      // Accède à la référence de v-autocomplete et déclenche la méthode blur pour fermer le menu
      this.$refs.autocomplete0.blur()
    }
  }
}
</script>
